/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import DashboardSidebar from "../../sidebar/index";
// import HeaderTwo from "../../fandashboard/newHeaderTwo.jsx";
import Footer from "../../home/footer.jsx";
import { TagsInput } from "react-tag-input-component";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
import {
    updateUserProfile,
    getCurrentUser,
    storeAuthData,
    getUserProfile,
    addCelebShoutouts,
    updateShoutoutPricing,
    getCelebShoutoutPricing
} from "../../../services/authService";
import { toast } from "react-toastify";
import Navbar from "../../landingpage/sections/Navbar/index.jsx";

// Cloudinary configuration
const CLOUD_NAME = "dcyzivpw4";
const UPLOAD_PRESET = "howzitone";

// Predefined shoutout types with their IDs
const SHOUTOUT_TYPES = [
    { id: "6895b7d08a07da4b1fb8cc06", name: "Birthday" },
    { id: "6895b7ba8a07da4b1fb8cc03", name: "Anniversary" }
];

const ProfileSetting = (props) => {
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [savingShoutout, setSavingShoutout] = useState(false);
    const [updatingShoutouts, setUpdatingShoutouts] = useState({}); // Track which shoutouts are being updated
    const [profileData, setProfileData] = useState({
        fullName: "",
        userPhone: "",
        profilepicture: "",
        email: "",
        dob: "",
        favoriteentertainment: [],
        socialmedialinks: []
    });

    // State for shoutout pricing
    const [shoutoutPricing, setShoutoutPricing] = useState([]);
    const [newShoutout, setNewShoutout] = useState({
        shoutoutId: "",
        price: "",
        status: "active"
    });

    // State for editing prices
    const [editingPrices, setEditingPrices] = useState({});

    useEffect(() => {
        loadUserProfile();
    }, []);

    const loadUserProfile = async () => {
        try {
            setLoading(true);
            const userData = getCurrentUser();

            if (userData) {
                const userId = userData._id || userData.id || userData.userId;

                if (userId) {
                    const response = await getUserProfile(userId);

                    if (response.success && response.data) {
                        const userProfile = response.data;
                        setProfileData({
                            fullName: userProfile.fullName || "",
                            userPhone: userProfile.userPhone || "",
                            profilepicture: userProfile.profilepicture || "",
                            email: userProfile.email || "",
                            dob: userProfile.dob ? userProfile.dob.split('T')[0] : "",
                            favoriteentertainment: userProfile.favoriteentertainment || [],
                            socialmedialinks: userProfile.socialmedialinks || []
                        });

                        // Load shoutout pricing from the dedicated endpoint
                        await loadShoutoutPricing();

                        storeAuthData(localStorage.getItem('token'), userProfile);
                    } else {
                        throw new Error(response.message || 'Failed to load user profile');
                    }
                } else {
                    setProfileData({
                        fullName: userData.fullName || "",
                        userPhone: userData.userPhone || "",
                        profilepicture: userData.profilepicture || "",
                        email: userData.email || "",
                        dob: userData.dob ? (typeof userData.dob === 'string' ? userData.dob.split('T')[0] : userData.dob) : "",
                        favoriteentertainment: userData.favoriteentertainment || [],
                        socialmedialinks: userData.socialmedialinks || []
                    });

                    // Load shoutout pricing even if using localStorage data
                    await loadShoutoutPricing();
                }
            } else {
                throw new Error('User not found in localStorage');
            }
        } catch (error) {
            console.error("Error loading profile:", error);
            // Don't show error toast if it's just a loading issue
            if (!error.message.includes('Failed to load user profile')) {
                toast.error(error.message || "Failed to load user profile");
            }

            const userData = getCurrentUser();
            if (userData) {
                setProfileData({
                    fullName: userData.fullName || "",
                    userPhone: userData.userPhone || "",
                    profilepicture: userData.profilepicture || "",
                    email: userData.email || "",
                    dob: userData.dob ? (typeof userData.dob === 'string' ? userData.dob.split('T')[0] : userData.dob) : "",
                    favoriteentertainment: userData.favoriteentertainment || [],
                    socialmedialinks: userData.socialmedialinks || []
                });

                // Try to load shoutout pricing even in error case
                await loadShoutoutPricing();
            }
        } finally {
            setLoading(false);
        }
    };

    // Load shoutout pricing from dedicated endpoint
    const loadShoutoutPricing = async () => {
        try {
            const response = await getCelebShoutoutPricing();

            if (response && response.message === 'Celebrity pricing retrieved successfully') {
                if (response.data && response.data.shoutout) {
                    // Transform the data to match your expected format
                    const pricingData = response.data.shoutout.map(item => ({
                        shoutoutId: item.shoutoutId,
                        shoutoutName: item.shoutname,
                        price: item.price,
                        status: item.status,
                        _id: item._id
                    }));
                    setShoutoutPricing(pricingData);

                    // Initialize editing prices with current prices
                    const initialEditingPrices = {};
                    pricingData.forEach(item => {
                        initialEditingPrices[item.shoutoutId] = item.price.toString();
                    });
                    setEditingPrices(initialEditingPrices);
                } else {
                    setShoutoutPricing([]);
                    setEditingPrices({});
                }
            } else {
                setShoutoutPricing([]);
                setEditingPrices({});
            }
        } catch (error) {
            console.error("Error loading shoutout pricing:", error);
            setShoutoutPricing([]);
            setEditingPrices({});
        }
    };

    // Shoutout Pricing Functions
    const handleNewShoutoutChange = (field, value) => {
        setNewShoutout(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const addShoutoutPricing = async () => {
        if (!newShoutout.shoutoutId || !newShoutout.price) {
            toast.error("Please select a shoutout type and enter a price");
            return;
        }

        try {
            setSavingShoutout(true);

            // Check if this shoutout type already exists
            const existingShoutout = shoutoutPricing.find(
                item => item.shoutoutId === newShoutout.shoutoutId
            );

            if (existingShoutout) {
                // Update existing shoutout
                const updateData = {
                    shoutoutId: newShoutout.shoutoutId,
                    price: parseFloat(newShoutout.price),
                    status: "active"
                };

                const response = await updateShoutoutPricing(updateData);
                if (response.success) {
                    // Update local state
                    const updatedPricing = shoutoutPricing.map(item =>
                        item.shoutoutId === newShoutout.shoutoutId
                            ? { ...item, price: parseFloat(newShoutout.price) }
                            : item
                    );
                    setShoutoutPricing(updatedPricing);

                    // Update editing price
                    setEditingPrices(prev => ({
                        ...prev,
                        [newShoutout.shoutoutId]: newShoutout.price
                    }));

                    toast.success("Shoutout pricing updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update shoutout pricing");
                }
            } else {
                // Add new shoutout using the add-celebs-shoutouts endpoint
                const requestData = {
                    shoutsouts: [{
                        shoutsoutId: newShoutout.shoutoutId,
                        price: parseFloat(newShoutout.price)
                    }]
                };

                const response = await addCelebShoutouts(requestData);

                if (response.success) {
                    // Add to local state
                    const shoutoutName = SHOUTOUT_TYPES.find(type => type.id === newShoutout.shoutoutId)?.name;
                    const newPricingItem = {
                        shoutoutId: newShoutout.shoutoutId,
                        shoutoutName: shoutoutName,
                        price: parseFloat(newShoutout.price),
                        status: "active"
                    };

                    setShoutoutPricing(prev => [...prev, newPricingItem]);
                    setEditingPrices(prev => ({
                        ...prev,
                        [newShoutout.shoutoutId]: newShoutout.price
                    }));

                    toast.success("Shoutout pricing added successfully!");

                    // Refresh from API to ensure consistency
                    setTimeout(() => {
                        loadShoutoutPricing();
                    }, 500);
                } else {
                    throw new Error(response.message || "Failed to add shoutout pricing");
                }
            }

            // Reset form
            setNewShoutout({
                shoutoutId: "",
                price: "",
                status: "active"
            });

        } catch (error) {
            console.error("Error saving shoutout pricing:", error);
            toast.error(error.message || "Failed to save shoutout pricing");
        } finally {
            setSavingShoutout(false);
        }
    };

    // Handle price input change for existing shoutouts
    const handlePriceChange = (shoutoutId, newPrice) => {
        setEditingPrices(prev => ({
            ...prev,
            [shoutoutId]: newPrice
        }));
    };

    // Update existing shoutout price
    const updateShoutoutPrice = async (shoutoutId) => {
        const newPrice = editingPrices[shoutoutId];

        if (!newPrice || parseFloat(newPrice) <= 0) {
            toast.error("Please enter a valid price");
            return;
        }

        try {
            setUpdatingShoutouts(prev => ({ ...prev, [shoutoutId]: true }));

            const updateData = {
                shoutoutId: shoutoutId,
                price: parseFloat(newPrice),
                status: "active"
            };

            const response = await updateShoutoutPricing(updateData);

            if (response.success) {
                // Update local state
                const updatedPricing = shoutoutPricing.map(item =>
                    item.shoutoutId === shoutoutId
                        ? { ...item, price: parseFloat(newPrice) }
                        : item
                );
                setShoutoutPricing(updatedPricing);
                toast.success("Shoutout pricing updated successfully!");
            } else {
                throw new Error(response.message || "Failed to update shoutout pricing");
            }
        } catch (error) {
            console.error("Error updating shoutout pricing:", error);
            toast.error(error.message || "Failed to update shoutout pricing");

            // Reset to original price on error
            const originalItem = shoutoutPricing.find(item => item.shoutoutId === shoutoutId);
            if (originalItem) {
                setEditingPrices(prev => ({
                    ...prev,
                    [shoutoutId]: originalItem.price.toString()
                }));
            }
        } finally {
            setUpdatingShoutouts(prev => ({ ...prev, [shoutoutId]: false }));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check if file is an image
        if (!file.type.startsWith('image/')) {
            toast.error('Please select an image file');
            return;
        }

        // Restrict to only JPG and PNG
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!allowedTypes.includes(file.type)) {
            toast.error('Please select only JPG or PNG images. SVG files are not allowed.');
            return;
        }

        // Check file extension as additional safety
        const fileName = file.name.toLowerCase();
        if (!fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && !fileName.endsWith('.png')) {
            toast.error('Please select only JPG or PNG images. SVG files are not allowed.');
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            toast.error('Image size should be less than 5MB');
            return;
        }

        setUploading(true);

        try {
            const imageUrl = await uploadImageToCloudinary(file);
            setProfileData(prev => ({
                ...prev,
                profilepicture: imageUrl
            }));
            toast.success('Profile picture uploaded successfully!');
        } catch (error) {
            console.error("Upload error:", error);
            toast.error(error.message || 'Failed to upload image');
        } finally {
            setUploading(false);
        }
    };

    const uploadImageToCloudinary = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", UPLOAD_PRESET);
        formData.append("folder", "howzit/profiles");

        const response = await fetch(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
            {
                method: "POST",
                body: formData,
            }
        );

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error?.message || 'Upload failed');
        }

        if (data.secure_url) {
            return data.secure_url;
        } else {
            throw new Error('Upload failed: No URL returned');
        }
    };

    const handleSocialLinkChange = (index, field, value) => {
        const updatedLinks = [...profileData.socialmedialinks];
        updatedLinks[index] = {
            ...updatedLinks[index],
            [field]: value
        };
        setProfileData(prev => ({
            ...prev,
            socialmedialinks: updatedLinks
        }));
    };

    const addSocialLink = () => {
        setProfileData(prev => ({
            ...prev,
            socialmedialinks: [...prev.socialmedialinks, { platform: "", url: "" }]
        }));
    };

    const removeSocialLink = async (index) => {
        // Remove from local state immediately
        const updatedLinks = profileData.socialmedialinks.filter((_, i) => i !== index);
        setProfileData(prev => ({
            ...prev,
            socialmedialinks: updatedLinks
        }));

        // Save the profile immediately to persist the change
        try {
            const updateData = {
                fullName: profileData.fullName,
                userPhone: profileData.userPhone,
                profilepicture: profileData.profilepicture,
                email: profileData.email,
                dob: profileData.dob,
                favoriteentertainment: profileData.favoriteentertainment,
                socialmedialinks: updatedLinks.filter(link => link.platform && link.url)
            };

            const response = await updateUserProfile(updateData);
            if (response.success) {
                const currentUser = getCurrentUser();
                const updatedUser = { ...currentUser, socialmedialinks: updatedLinks };
                storeAuthData(localStorage.getItem('token'), updatedUser);
                toast.success("Social media link removed successfully!");
            }
        } catch (error) {
            console.error("Error saving profile after removing social link:", error);
            toast.error("Failed to save profile changes");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const updateData = {
                fullName: profileData.fullName,
                userPhone: profileData.userPhone,
                profilepicture: profileData.profilepicture,
                email: profileData.email,
                dob: profileData.dob,
                favoriteentertainment: profileData.favoriteentertainment,
                socialmedialinks: profileData.socialmedialinks.filter(link =>
                    link.platform && link.url
                )
            };

            const response = await updateUserProfile(updateData);
            if (response.success) {
                const currentUser = getCurrentUser();
                const updatedUser = { ...currentUser, ...response.data };
                storeAuthData(localStorage.getItem('token'), updatedUser);

                toast.success("Profile updated successfully!");
            } else {
                throw new Error(response.message || "Failed to update profile");
            }
        } catch (error) {
            console.error("Update error:", error);
            toast.error(error.message || "Failed to update profile");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Navbar {...props} />
            {/* Breadcrumb */}
            <div className="breadcrumb-bar"
                style={{
                    backgroundColor: 'var(--breadcrumb-bg)',
                    transition: 'background-color 0.3s ease'
                }}
            >
                <div className="container">
                    <div className="row align-items-center inner-banner">
                        <div className="col-md-12 col-12 text-center">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="/">
                                            <i className="isax isax-home-15" />
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">
                                        Celeb
                                    </li>
                                    <li className="breadcrumb-item active">Celeb Profile</li>
                                </ol>
                                <h2 className="breadcrumb-title">Celeb Profile</h2>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-bg">
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-bg-01.png"
                        alt="img"
                        className="breadcrumb-bg-01"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-bg-02.png"
                        alt="img"
                        className="breadcrumb-bg-02"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-icon.png"
                        alt="img"
                        className="breadcrumb-bg-03"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/breadcrumb-icon.png"
                        alt="img"
                        className="breadcrumb-bg-04"
                    />
                </div>
            </div>

            {/* Page Content */}
            <div className="content doctor-content">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-xl-3 theiaStickySidebar">
                            <DashboardSidebar />
                        </div>
                        <div className="col-lg-8 col-xl-9">
                            <div className="dashboard-header">
                                <h3>Profile Settings</h3>
                            </div>

                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2">Loading profile...</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    {/* Profile Image */}
                                    <div className="setting-title">
                                        <h5>Profile</h5>
                                    </div>
                                    <div className="setting-card">
                                        <div className="change-avatar img-upload">
                                            <div className="profile-img">
                                                {profileData.profilepicture ? (
                                                    <img
                                                        src={profileData.profilepicture}
                                                        alt="Profile"
                                                        className="img-fluid rounded-circle"
                                                        style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                        onError={(e) => {
                                                            e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='12' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E";
                                                        }}
                                                    />
                                                ) : (
                                                    <i className="fa-solid fa-user" style={{ fontSize: '48px' }} />
                                                )}
                                            </div>
                                            <div className="upload-img">
                                                <h5>Profile Image</h5>
                                                <div className="form-wrap">
                                                    <label className="col-form-label">Upload New Picture</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                                        onChange={handleFileChange}
                                                        disabled={uploading}
                                                    />
                                                    {uploading && (
                                                        <div className="mt-2">
                                                            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                                                <span className="visually-hidden">Uploading...</span>
                                                            </div>
                                                            <small className="text-muted">Uploading image...</small>
                                                        </div>
                                                    )}
                                                </div>
                                                <p className="form-text">
                                                    Select an image file (JPG, PNG only). Max size: 5MB
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Personal Information */}
                                    <div className="setting-title">
                                        <h5>Personal Information</h5>
                                    </div>
                                    <div className="setting-card">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-wrap">
                                                    <label className="col-form-label">
                                                        Full Name <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="fullName"
                                                        value={profileData.fullName}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-wrap">
                                                    <label className="col-form-label">
                                                        Phone Number <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="userPhone"
                                                        value={profileData.userPhone}
                                                        onChange={handleInputChange}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-wrap">
                                                    <label className="col-form-label">
                                                        Email Address <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        value={profileData.email}
                                                        onChange={handleInputChange}
                                                        readOnly
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-wrap">
                                                    <label className="col-form-label">
                                                        Date of Birth
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="dob"
                                                        value={profileData.dob}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Shoutout Pricing Section */}
                                    <div className="setting-title">
                                        <h5>Shoutout Pricing</h5>
                                    </div>
                                    <div className="setting-card">
                                        <div className="form-wrap">
                                            {/* Add New Shoutout Pricing */}
                                            <div className="row mb-4">
                                                <div className="col-md-5">
                                                    <div className="form-wrap">
                                                        <label className="col-form-label">Shoutout Type</label>
                                                        <select
                                                            className="form-control"
                                                            value={newShoutout.shoutoutId}
                                                            onChange={(e) => handleNewShoutoutChange('shoutoutId', e.target.value)}
                                                        >
                                                            <option value="">Select shoutout type</option>
                                                            {SHOUTOUT_TYPES.map(type => (
                                                                <option key={type.id} value={type.id}>
                                                                    {type.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="form-wrap">
                                                        <label className="col-form-label">Price ($)</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Enter price"
                                                            value={newShoutout.price}
                                                            onChange={(e) => handleNewShoutoutChange('price', e.target.value)}
                                                            min="0"
                                                            step="0.01"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary w-100"
                                                        onClick={addShoutoutPricing}
                                                        disabled={savingShoutout}
                                                        style={{ marginTop: '30px' }}
                                                    >
                                                        {savingShoutout ? "Saving..." : "Add"}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Existing Shoutout Pricing */}
                                            {shoutoutPricing.length > 0 ? (
                                                shoutoutPricing.map((shoutout, index) => (
                                                    <div className="row mb-3" key={shoutout.shoutoutId || index}>
                                                        <div className="col-md-3">
                                                            <div className="form-wrap">
                                                                <label className="col-form-label">Type</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={shoutout.shoutoutName || SHOUTOUT_TYPES.find(t => t.id === shoutout.shoutoutId)?.name || "Shoutout"}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-wrap">
                                                                <label className="col-form-label">Current Price ($)</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={shoutout.price}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="form-wrap">
                                                                <label className="col-form-label">New Price ($)</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Enter new price"
                                                                    value={editingPrices[shoutout.shoutoutId] || ""}
                                                                    onChange={(e) => handlePriceChange(shoutout.shoutoutId, e.target.value)}
                                                                    min="0"
                                                                    step="0.01"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3"> {/* Keep original column size */}
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary w-100"
                                                                onClick={() => updateShoutoutPrice(shoutout.shoutoutId)}
                                                                disabled={updatingShoutouts[shoutout.shoutoutId] || !editingPrices[shoutout.shoutoutId] || parseFloat(editingPrices[shoutout.shoutoutId]) <= 0}
                                                                style={{
                                                                    marginTop: '30px' /* Keep original desktop margin */
                                                                }}
                                                            >
                                                                {updatingShoutouts[shoutout.shoutoutId] ? "Updating..." : "Update Price"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="text-center text-muted py-3">
                                                    No shoutout pricing set yet. Add your first shoutout pricing above.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Favorite Entertainment */}
                                    <div className="setting-title">
                                        <h5>Favorite entertainment</h5>
                                    </div>
                                    <div className="setting-card">
                                        <div className="form-wrap">
                                            <label className="col-form-label">
                                                Favorite Entertainment Types
                                            </label>
                                            <TagsInput
                                                value={profileData.favoriteentertainment}
                                                onChange={(tags) => setProfileData(prev => ({ ...prev, favoriteentertainment: tags }))}
                                                placeHolder="Add entertainment types (press Enter)"
                                            />
                                        </div>
                                    </div>

                                    {/* Social Media Links */}
                                    <div className="setting-title">
                                        <h5>Social Media Links</h5>
                                    </div>
                                    <div className="setting-card">
                                        {profileData.socialmedialinks.map((link, index) => (
                                            <div className="row mb-3" key={index}>
                                                <div className="col-md-5">
                                                    <div className="form-wrap">
                                                        <label className="col-form-label">Platform</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={link.platform}
                                                            onChange={(e) => handleSocialLinkChange(index, 'platform', e.target.value)}
                                                            placeholder="Platform name"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="form-wrap">
                                                        <label className="col-form-label">URL</label>
                                                        <input
                                                            type="url"
                                                            className="form-control"
                                                            value={link.url}
                                                            onChange={(e) => handleSocialLinkChange(index, 'url', e.target.value)}
                                                            placeholder="https://..."
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm w-100"
                                                        onClick={() => removeSocialLink(index)}
                                                        style={{ marginTop: '30px' }}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            </div>
                                        ))}

                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={addSocialLink}
                                        >
                                            + Add Social Media Link
                                        </button>
                                    </div>
                                    {/* Submit Buttons */}
                                    <div className="modal-btn text-end mt-4">
                                        <Link to="/dashboard" className="btn btn-gray me-2">
                                            Cancel
                                        </Link>
                                        <button
                                            type="submit"
                                            className="btn btn-primary prime-btn"
                                            disabled={loading || uploading}
                                        >
                                            {loading ? "Saving..." : "Save Changes"}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer {...props} />
        </div>
    );
};

export default ProfileSetting;


// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable react/prop-types */
// import React, { useState, useEffect } from "react";
// import DashboardSidebar from "../../sidebar/index";
// import HeaderTwo from "../../fandashboard/newHeaderTwo.jsx";
// import Footer from "../../home/footer.jsx";
// import { TagsInput } from "react-tag-input-component";
// import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../../core/img/imagewithbasebath.jsx";
// import {
//     updateUserProfile,
//     getCurrentUser,
//     storeAuthData,
//     getUserProfile,
//     addCelebShoutouts,
//     updateShoutoutPricing,
//     deleteShoutoutPricing,
//     getCelebShoutoutPricing
// } from "../../../services/authService";
// import { toast } from "react-toastify";

// // Cloudinary configuration
// const CLOUD_NAME = "dcyzivpw4";
// const UPLOAD_PRESET = "howzitone";

// // Predefined shoutout types with their IDs
// const SHOUTOUT_TYPES = [
//     { id: "6895b7d08a07da4b1fb8cc06", name: "Birthday" },
//     { id: "6895b7ba8a07da4b1fb8cc03", name: "Anniversary" }
// ];

// const ProfileSetting = (props) => {
//     const [loading, setLoading] = useState(false);
//     const [uploading, setUploading] = useState(false);
//     const [savingShoutout, setSavingShoutout] = useState(false);
//     const [profileData, setProfileData] = useState({
//         fullName: "",
//         userPhone: "",
//         profilepicture: "",
//         email: "",
//         dob: "",
//         favoriteentertainment: [],
//         socialmedialinks: []
//     });

//     // State for shoutout pricing
//     const [shoutoutPricing, setShoutoutPricing] = useState([]);
//     const [newShoutout, setNewShoutout] = useState({
//         shoutoutId: "",
//         price: "",
//         status: "active"
//     });

//     useEffect(() => {
//         loadUserProfile();
//     }, []);

//     const loadUserProfile = async () => {
//         try {
//             setLoading(true);
//             const userData = getCurrentUser();

//             if (userData) {
//                 const userId = userData._id || userData.id || userData.userId;

//                 if (userId) {
//                     const response = await getUserProfile(userId);

//                     if (response.success && response.data) {
//                         const userProfile = response.data;
//                         setProfileData({
//                             fullName: userProfile.fullName || "",
//                             userPhone: userProfile.userPhone || "",
//                             profilepicture: userProfile.profilepicture || "",
//                             email: userProfile.email || "",
//                             dob: userProfile.dob ? userProfile.dob.split('T')[0] : "",
//                             favoriteentertainment: userProfile.favoriteentertainment || [],
//                             socialmedialinks: userProfile.socialmedialinks || []
//                         });

//                         // Load shoutout pricing from the dedicated endpoint
//                         await loadShoutoutPricing();

//                         storeAuthData(localStorage.getItem('token'), userProfile);
//                     } else {
//                         throw new Error(response.message || 'Failed to load user profile');
//                     }
//                 } else {
//                     setProfileData({
//                         fullName: userData.fullName || "",
//                         userPhone: userData.userPhone || "",
//                         profilepicture: userData.profilepicture || "",
//                         email: userData.email || "",
//                         dob: userData.dob ? (typeof userData.dob === 'string' ? userData.dob.split('T')[0] : userData.dob) : "",
//                         favoriteentertainment: userData.favoriteentertainment || [],
//                         socialmedialinks: userData.socialmedialinks || []
//                     });

//                     // Load shoutout pricing even if using localStorage data
//                     await loadShoutoutPricing();
//                 }
//             } else {
//                 throw new Error('User not found in localStorage');
//             }
//         } catch (error) {
//             console.error("Error loading profile:", error);
//             // Don't show error toast if it's just a loading issue
//             if (!error.message.includes('Failed to load user profile')) {
//                 toast.error(error.message || "Failed to load user profile");
//             }

//             const userData = getCurrentUser();
//             if (userData) {
//                 setProfileData({
//                     fullName: userData.fullName || "",
//                     userPhone: userData.userPhone || "",
//                     profilepicture: userData.profilepicture || "",
//                     email: userData.email || "",
//                     dob: userData.dob ? (typeof userData.dob === 'string' ? userData.dob.split('T')[0] : userData.dob) : "",
//                     favoriteentertainment: userData.favoriteentertainment || [],
//                     socialmedialinks: userData.socialmedialinks || []
//                 });

//                 // Try to load shoutout pricing even in error case
//                 await loadShoutoutPricing();
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Load shoutout pricing from dedicated endpoint
//     const loadShoutoutPricing = async () => {
//         try {
//             const response = await getCelebShoutoutPricing();

//             if (response && response.message === 'Celebrity pricing retrieved successfully') {
//                 if (response.data && response.data.shoutout) {
//                     // Transform the data to match your expected format
//                     const pricingData = response.data.shoutout.map(item => ({
//                         shoutoutId: item.shoutoutId,
//                         shoutoutName: item.shoutname,
//                         price: item.price,
//                         status: item.status,
//                         _id: item._id
//                     }));
//                     setShoutoutPricing(pricingData);
//                 } else {
//                     setShoutoutPricing([]);
//                 }
//             } else {
//                 setShoutoutPricing([]);
//             }
//         } catch (error) {
//             console.error("Error loading shoutout pricing:", error);
//             setShoutoutPricing([]);
//         }
//     };

//     // Shoutout Pricing Functions
//     const handleNewShoutoutChange = (field, value) => {
//         setNewShoutout(prev => ({
//             ...prev,
//             [field]: value
//         }));
//     };

//     const addShoutoutPricing = async () => {
//         if (!newShoutout.shoutoutId || !newShoutout.price) {
//             toast.error("Please select a shoutout type and enter a price");
//             return;
//         }

//         try {
//             setSavingShoutout(true);

//             // Check if this shoutout type already exists
//             const existingShoutout = shoutoutPricing.find(
//                 item => item.shoutoutId === newShoutout.shoutoutId
//             );

//             if (existingShoutout) {
//                 // Update existing shoutout
//                 const updateData = {
//                     shoutoutId: newShoutout.shoutoutId,
//                     price: parseFloat(newShoutout.price),
//                     status: "active"
//                 };

//                 const response = await updateShoutoutPricing(updateData);
//                 if (response.success) {
//                     // Update local state immediately for better UX
//                     const updatedPricing = shoutoutPricing.map(item =>
//                         item.shoutoutId === newShoutout.shoutoutId
//                             ? { ...item, price: parseFloat(newShoutout.price) }
//                             : item
//                     );
//                     setShoutoutPricing(updatedPricing);
//                     toast.success("Shoutout pricing updated successfully!");
//                 } else {
//                     throw new Error(response.message || "Failed to update shoutout pricing");
//                 }
//             } else {
//                 // Add new shoutout using the add-celebs-shoutouts endpoint
//                 const requestData = {
//                     shoutsouts: [{
//                         shoutsoutId: newShoutout.shoutoutId,
//                         price: parseFloat(newShoutout.price)
//                     }]
//                 };

//                 const response = await addCelebShoutouts(requestData);

//                 if (response.success) {
//                     // Add to local state immediately for better UX
//                     const shoutoutName = SHOUTOUT_TYPES.find(type => type.id === newShoutout.shoutoutId)?.name;
//                     setShoutoutPricing(prev => [
//                         ...prev,
//                         {
//                             shoutoutId: newShoutout.shoutoutId,
//                             shoutoutName: shoutoutName,
//                             price: parseFloat(newShoutout.price),
//                             status: "active"
//                         }
//                     ]);
//                     toast.success("Shoutout pricing added successfully!");
//                 } else {
//                     throw new Error(response.message || "Failed to add shoutout pricing");
//                 }
//             }

//             // Reset form
//             setNewShoutout({
//                 shoutoutId: "",
//                 price: "",
//                 status: "active"
//             });

//         } catch (error) {
//             console.error("Error saving shoutout pricing:", error);
//             toast.error(error.message || "Failed to save shoutout pricing");
//         } finally {
//             setSavingShoutout(false);
//         }
//     };

//     const updateExistingShoutout = async (shoutoutId, newPrice) => {
//         if (!newPrice || parseFloat(newPrice) <= 0) {
//             toast.error("Please enter a valid price");
//             return;
//         }

//         try {
//             setSavingShoutout(true);
//             const updateData = {
//                 shoutoutId: shoutoutId,
//                 price: parseFloat(newPrice),
//                 status: "active"
//             };

//             const response = await updateShoutoutPricing(updateData);

//             if (response.success) {
//                 const updatedPricing = shoutoutPricing.map(item =>
//                     item.shoutoutId === shoutoutId
//                         ? { ...item, price: parseFloat(newPrice) }
//                         : item
//                 );
//                 setShoutoutPricing(updatedPricing);
//                 toast.success("Shoutout pricing updated successfully!");
//             } else {
//                 throw new Error(response.message || "Failed to update shoutout pricing");
//             }
//         } catch (error) {
//             console.error("Error updating shoutout pricing:", error);
//             toast.error(error.message || "Failed to update shoutout pricing");
//         } finally {
//             setSavingShoutout(false);
//         }
//     };

//     const removeShoutout = async (shoutoutId) => {
//         if (!window.confirm("Are you sure you want to remove this shoutout pricing?")) {
//             return;
//         }

//         try {
//             setSavingShoutout(true);

//             // Find the pricing record to get its _id for deletion
//             const pricingRecord = shoutoutPricing.find(item => item.shoutoutId === shoutoutId);

//             if (!pricingRecord) {
//                 toast.error("Pricing record not found");
//                 return;
//             }

//             // Use the _id for deletion (not shoutoutId)
//             const response = await deleteShoutoutPricing(pricingRecord._id);

//             if (response.success) {
//                 // Remove from local state immediately
//                 setShoutoutPricing(prev => prev.filter(item => item.shoutoutId !== shoutoutId));
//                 toast.success("Shoutout pricing removed successfully!");
//             } else {
//                 throw new Error(response.message || "Failed to remove shoutout pricing");
//             }
//         } catch (error) {
//             console.error("Error deleting shoutout pricing:", error);
//             toast.error(error.message || "Failed to remove shoutout pricing");
//         } finally {
//             setSavingShoutout(false);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setProfileData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleFileChange = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         // Check if file is an image
//         if (!file.type.startsWith('image/')) {
//             toast.error('Please select an image file');
//             return;
//         }

//         // Restrict to only JPG and PNG
//         const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
//         if (!allowedTypes.includes(file.type)) {
//             toast.error('Please select only JPG or PNG images. SVG files are not allowed.');
//             return;
//         }

//         // Check file extension as additional safety
//         const fileName = file.name.toLowerCase();
//         if (!fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && !fileName.endsWith('.png')) {
//             toast.error('Please select only JPG or PNG images. SVG files are not allowed.');
//             return;
//         }

//         if (file.size > 5 * 1024 * 1024) {
//             toast.error('Image size should be less than 5MB');
//             return;
//         }

//         setUploading(true);

//         try {
//             const imageUrl = await uploadImageToCloudinary(file);
//             setProfileData(prev => ({
//                 ...prev,
//                 profilepicture: imageUrl
//             }));
//             toast.success('Profile picture uploaded successfully!');
//         } catch (error) {
//             console.error("Upload error:", error);
//             toast.error(error.message || 'Failed to upload image');
//         } finally {
//             setUploading(false);
//         }
//     };

//     const uploadImageToCloudinary = async (file) => {
//         const formData = new FormData();
//         formData.append("file", file);
//         formData.append("upload_preset", UPLOAD_PRESET);
//         formData.append("folder", "howzit/profiles");

//         const response = await fetch(
//             `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
//             {
//                 method: "POST",
//                 body: formData,
//             }
//         );

//         const data = await response.json();

//         if (!response.ok) {
//             throw new Error(data.error?.message || 'Upload failed');
//         }

//         if (data.secure_url) {
//             return data.secure_url;
//         } else {
//             throw new Error('Upload failed: No URL returned');
//         }
//     };

//     const handleSocialLinkChange = (index, field, value) => {
//         const updatedLinks = [...profileData.socialmedialinks];
//         updatedLinks[index] = {
//             ...updatedLinks[index],
//             [field]: value
//         };
//         setProfileData(prev => ({
//             ...prev,
//             socialmedialinks: updatedLinks
//         }));
//     };

//     const addSocialLink = () => {
//         setProfileData(prev => ({
//             ...prev,
//             socialmedialinks: [...prev.socialmedialinks, { platform: "", url: "" }]
//         }));
//     };

//     const removeSocialLink = async (index) => {
//         // Remove from local state immediately
//         const updatedLinks = profileData.socialmedialinks.filter((_, i) => i !== index);
//         setProfileData(prev => ({
//             ...prev,
//             socialmedialinks: updatedLinks
//         }));

//         // Save the profile immediately to persist the change
//         try {
//             const updateData = {
//                 fullName: profileData.fullName,
//                 userPhone: profileData.userPhone,
//                 profilepicture: profileData.profilepicture,
//                 email: profileData.email,
//                 dob: profileData.dob,
//                 favoriteentertainment: profileData.favoriteentertainment,
//                 socialmedialinks: updatedLinks.filter(link => link.platform && link.url)
//             };

//             const response = await updateUserProfile(updateData);
//             if (response.success) {
//                 const currentUser = getCurrentUser();
//                 const updatedUser = { ...currentUser, socialmedialinks: updatedLinks };
//                 storeAuthData(localStorage.getItem('token'), updatedUser);
//                 toast.success("Social media link removed successfully!");
//             }
//         } catch (error) {
//             console.error("Error saving profile after removing social link:", error);
//             toast.error("Failed to save profile changes");
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         try {
//             const updateData = {
//                 fullName: profileData.fullName,
//                 userPhone: profileData.userPhone,
//                 profilepicture: profileData.profilepicture,
//                 email: profileData.email,
//                 dob: profileData.dob,
//                 favoriteentertainment: profileData.favoriteentertainment,
//                 socialmedialinks: profileData.socialmedialinks.filter(link =>
//                     link.platform && link.url
//                 )
//             };

//             const response = await updateUserProfile(updateData);
//             if (response.success) {
//                 const currentUser = getCurrentUser();
//                 const updatedUser = { ...currentUser, ...response.data };
//                 storeAuthData(localStorage.getItem('token'), updatedUser);

//                 toast.success("Profile updated successfully!");
//             } else {
//                 throw new Error(response.message || "Failed to update profile");
//             }
//         } catch (error) {
//             console.error("Update error:", error);
//             toast.error(error.message || "Failed to update profile");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div>
//             <HeaderTwo {...props} />
//             {/* Breadcrumb */}
//             <div className="breadcrumb-bar"
//                 style={{
//                     backgroundColor: 'var(--breadcrumb-bg)',
//                     transition: 'background-color 0.3s ease'
//                 }}
//             >
//                 <div className="container">
//                     <div className="row align-items-center inner-banner">
//                         <div className="col-md-12 col-12 text-center">
//                             <nav aria-label="breadcrumb" className="page-breadcrumb">
//                                 <ol className="breadcrumb">
//                                     <li className="breadcrumb-item">
//                                         <a href="/">
//                                             <i className="isax isax-home-15" />
//                                         </a>
//                                     </li>
//                                     <li className="breadcrumb-item" aria-current="page">
//                                         Celeb
//                                     </li>
//                                     <li className="breadcrumb-item active">Celeb Profile</li>
//                                 </ol>
//                                 <h2 className="breadcrumb-title">Celeb Profile</h2>
//                             </nav>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="breadcrumb-bg">
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-bg-01.png"
//                         alt="img"
//                         className="breadcrumb-bg-01"
//                     />
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-bg-02.png"
//                         alt="img"
//                         className="breadcrumb-bg-02"
//                     />
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-icon.png"
//                         alt="img"
//                         className="breadcrumb-bg-03"
//                     />
//                     <ImageWithBasePath
//                         src="assets/img/bg/breadcrumb-icon.png"
//                         alt="img"
//                         className="breadcrumb-bg-04"
//                     />
//                 </div>
//             </div>

//             {/* Page Content */}
//             <div className="content doctor-content">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-4 col-xl-3 theiaStickySidebar">
//                             <DashboardSidebar />
//                         </div>
//                         <div className="col-lg-8 col-xl-9">
//                             <div className="dashboard-header">
//                                 <h3>Profile Settings</h3>
//                             </div>

//                             {loading ? (
//                                 <div className="text-center py-4">
//                                     <div className="spinner-border text-primary" role="status">
//                                         <span className="visually-hidden">Loading...</span>
//                                     </div>
//                                     <p className="mt-2">Loading profile...</p>
//                                 </div>
//                             ) : (
//                                 <form onSubmit={handleSubmit}>
//                                     {/* Profile Image */}
//                                     <div className="setting-title">
//                                         <h5>Profile</h5>
//                                     </div>
//                                     <div className="setting-card">
//                                         <div className="change-avatar img-upload">
//                                             <div className="profile-img">
//                                                 {profileData.profilepicture ? (
//                                                     <img
//                                                         src={profileData.profilepicture}
//                                                         alt="Profile"
//                                                         className="img-fluid rounded-circle"
//                                                         style={{ width: '100px', height: '100px', objectFit: 'cover' }}
//                                                         onError={(e) => {
//                                                             e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='12' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E";
//                                                         }}
//                                                     />
//                                                 ) : (
//                                                     <i className="fa-solid fa-user" style={{ fontSize: '48px' }} />
//                                                 )}
//                                             </div>
//                                             <div className="upload-img">
//                                                 <h5>Profile Image</h5>
//                                                 <div className="form-wrap">
//                                                     <label className="col-form-label">Upload New Picture</label>
//                                                     <input
//                                                         type="file"
//                                                         className="form-control"
//                                                         accept=".jpg,.jpeg,.png,image/jpeg,image/png"
//                                                         onChange={handleFileChange}
//                                                         disabled={uploading}
//                                                     />
//                                                     {uploading && (
//                                                         <div className="mt-2">
//                                                             <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
//                                                                 <span className="visually-hidden">Uploading...</span>
//                                                             </div>
//                                                             <small className="text-muted">Uploading image...</small>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                                 <p className="form-text">
//                                                     Select an image file (JPG, PNG only). Max size: 5MB
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Personal Information */}
//                                     <div className="setting-title">
//                                         <h5>Personal Information</h5>
//                                     </div>
//                                     <div className="setting-card">
//                                         <div className="row">
//                                             <div className="col-md-6">
//                                                 <div className="form-wrap">
//                                                     <label className="col-form-label">
//                                                         Full Name <span className="text-danger">*</span>
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         name="fullName"
//                                                         value={profileData.fullName}
//                                                         onChange={handleInputChange}
//                                                         required
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6">
//                                                 <div className="form-wrap">
//                                                     <label className="col-form-label">
//                                                         Phone Number <span className="text-danger">*</span>
//                                                     </label>
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         name="userPhone"
//                                                         value={profileData.userPhone}
//                                                         onChange={handleInputChange}
//                                                         readOnly
//                                                         required
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6">
//                                                 <div className="form-wrap">
//                                                     <label className="col-form-label">
//                                                         Email Address <span className="text-danger">*</span>
//                                                     </label>
//                                                     <input
//                                                         type="email"
//                                                         className="form-control"
//                                                         name="email"
//                                                         value={profileData.email}
//                                                         onChange={handleInputChange}
//                                                         readOnly
//                                                         required
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-6">
//                                                 <div className="form-wrap">
//                                                     <label className="col-form-label">
//                                                         Date of Birth
//                                                     </label>
//                                                     <input
//                                                         type="date"
//                                                         className="form-control"
//                                                         name="dob"
//                                                         value={profileData.dob}
//                                                         onChange={handleInputChange}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Shoutout Pricing Section */}
//                                     <div className="setting-title">
//                                         <h5>Shoutout Pricing</h5>
//                                     </div>
//                                     <div className="setting-card">
//                                         <div className="form-wrap">
//                                             {/* Add New Shoutout Pricing */}
//                                             <div className="row mb-4">
//                                                 <div className="col-md-5">
//                                                     <div className="form-wrap">
//                                                         <label className="col-form-label">Shoutout Type</label>
//                                                         <select
//                                                             className="form-control"
//                                                             value={newShoutout.shoutoutId}
//                                                             onChange={(e) => handleNewShoutoutChange('shoutoutId', e.target.value)}
//                                                         >
//                                                             <option value="">Select shoutout type</option>
//                                                             {SHOUTOUT_TYPES.map(type => (
//                                                                 <option key={type.id} value={type.id}>
//                                                                     {type.name}
//                                                                 </option>
//                                                             ))}
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-5">
//                                                     <div className="form-wrap">
//                                                         <label className="col-form-label">Price ($)</label>
//                                                         <input
//                                                             type="number"
//                                                             className="form-control"
//                                                             placeholder="Enter price"
//                                                             value={newShoutout.price}
//                                                             onChange={(e) => handleNewShoutoutChange('price', e.target.value)}
//                                                             min="0"
//                                                             step="0.01"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2">
//                                                     <label className="col-form-label">&nbsp;</label>
//                                                     <button
//                                                         type="button"
//                                                         className="btn btn-primary w-100"
//                                                         onClick={addShoutoutPricing}
//                                                         disabled={savingShoutout}
//                                                         style={{ marginTop: '30px' }}
//                                                     >
//                                                         {savingShoutout ? "Saving..." : "Add"}
//                                                     </button>
//                                                 </div>
//                                             </div>

//                                             {/* Existing Shoutout Pricing */}
//                                             {shoutoutPricing.length > 0 ? (
//                                                 shoutoutPricing.map((shoutout, index) => (
//                                                     <div className="row mb-3" key={shoutout.shoutoutId || index}>
//                                                         <div className="col-md-4">
//                                                             <div className="form-wrap">
//                                                                 <label className="col-form-label">Type</label>
//                                                                 <input
//                                                                     type="text"
//                                                                     className="form-control"
//                                                                     value={shoutout.shoutoutName || SHOUTOUT_TYPES.find(t => t.id === shoutout.shoutoutId)?.name || "Shoutout"}
//                                                                     readOnly
//                                                                 />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-md-4">
//                                                             <div className="form-wrap">
//                                                                 <label className="col-form-label">Price ($)</label>
//                                                                 <input
//                                                                     type="number"
//                                                                     className="form-control"
//                                                                     value={shoutout.price}
//                                                                     onChange={(e) => updateExistingShoutout(shoutout.shoutoutId, e.target.value)}
//                                                                     min="0"
//                                                                     step="0.01"
//                                                                 />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-md-2">
//                                                             <div className="form-wrap">
//                                                                 <label className="col-form-label">Status</label>
//                                                                 <input
//                                                                     type="text"
//                                                                     className="form-control"
//                                                                     value={shoutout.status}
//                                                                     readOnly
//                                                                 />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-md-2">
//                                                             <label className="col-form-label">&nbsp;</label>
//                                                             <button
//                                                                 type="button"
//                                                                 className="btn btn-danger btn-sm w-100"
//                                                                 onClick={() => removeShoutout(shoutout.shoutoutId)}
//                                                                 disabled={savingShoutout}
//                                                                 style={{ marginTop: '30px' }}
//                                                             >
//                                                                 {savingShoutout ? "Removing..." : "Remove"}
//                                                             </button>
//                                                         </div>
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="text-center text-muted py-3">
//                                                     No shoutout pricing set yet. Add your first shoutout pricing above.
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>

//                                     {/* Favorite Entertainment */}
//                                     <div className="setting-title">
//                                         <h5>Favorite entertainment</h5>
//                                     </div>
//                                     <div className="setting-card">
//                                         <div className="form-wrap">
//                                             <label className="col-form-label">
//                                                 Favorite Entertainment Types
//                                             </label>
//                                             <TagsInput
//                                                 value={profileData.favoriteentertainment}
//                                                 onChange={(tags) => setProfileData(prev => ({ ...prev, favoriteentertainment: tags }))}
//                                                 placeHolder="Add entertainment types (press Enter)"
//                                             />
//                                         </div>
//                                     </div>

//                                     {/* Social Media Links */}
//                                     <div className="setting-title">
//                                         <h5>Social Media Links</h5>
//                                     </div>
//                                     <div className="setting-card">
//                                         {profileData.socialmedialinks.map((link, index) => (
//                                             <div className="row mb-3" key={index}>
//                                                 <div className="col-md-5">
//                                                     <div className="form-wrap">
//                                                         <label className="col-form-label">Platform</label>
//                                                         <input
//                                                             type="text"
//                                                             className="form-control"
//                                                             value={link.platform}
//                                                             onChange={(e) => handleSocialLinkChange(index, 'platform', e.target.value)}
//                                                             placeholder="Platform name"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-5">
//                                                     <div className="form-wrap">
//                                                         <label className="col-form-label">URL</label>
//                                                         <input
//                                                             type="url"
//                                                             className="form-control"
//                                                             value={link.url}
//                                                             onChange={(e) => handleSocialLinkChange(index, 'url', e.target.value)}
//                                                             placeholder="https://..."
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2">
//                                                     <label className="col-form-label">&nbsp;</label>
//                                                     <button
//                                                         type="button"
//                                                         className="btn btn-danger btn-sm w-100"
//                                                         onClick={() => removeSocialLink(index)}
//                                                         style={{ marginTop: '30px' }}
//                                                     >
//                                                         Remove
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))}

//                                         <button
//                                             type="button"
//                                             className="btn btn-outline-primary btn-sm"
//                                             onClick={addSocialLink}
//                                         >
//                                             + Add Social Media Link
//                                         </button>
//                                     </div>

//                                     {/* Submit Buttons */}
//                                     <div className="modal-btn text-end mt-4">
//                                         <Link to="/dashboard" className="btn btn-gray me-2">
//                                             Cancel
//                                         </Link>
//                                         <button
//                                             type="submit"
//                                             className="btn btn-primary prime-btn"
//                                             disabled={loading || uploading}
//                                         >
//                                             {loading ? "Saving..." : "Save Changes"}
//                                         </button>
//                                     </div>
//                                 </form>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Footer {...props} />
//         </div>
//     );
// };

// export default ProfileSetting;